var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6151 0C18.6428 0 22.2643 1.61692 24.8735 3.62C26.1812 4.62308 27.2535 5.73692 28.0059 6.82C28.7443 7.88461 29.2305 9.00154 29.2305 10C29.2305 10.9985 28.7428 12.1154 28.0059 13.1785C27.252 14.2631 26.1812 15.3769 24.8735 16.3785C22.2643 18.3846 18.6428 20 14.6151 20C10.5874 20 6.96586 18.3831 4.35662 16.38C3.04893 15.3769 1.97663 14.2631 1.22586 13.18C0.487394 12.1154 -0.000299454 10.9985 -0.000299454 10C-0.000299454 9.00154 0.487394 7.88462 1.22586 6.82154C1.97663 5.73692 3.04893 4.62308 4.35662 3.62154C6.96586 1.61538 10.5874 0 14.6151 0ZM20.3843 10C20.3843 8.4699 19.7765 7.00248 18.6945 5.92054C17.6126 4.8386 16.1452 4.23077 14.6151 4.23077C13.085 4.23077 11.6176 4.8386 10.5356 5.92054C9.45368 7.00248 8.84585 8.4699 8.84585 10C8.84585 11.5301 9.45368 12.9975 10.5356 14.0795C11.6176 15.1614 13.085 15.7692 14.6151 15.7692C16.1452 15.7692 17.6126 15.1614 18.6945 14.0795C19.7765 12.9975 20.3843 11.5301 20.3843 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.728d2df2f576a285b1a9d382d88bf148.svg";
export { ForwardRef as ReactComponent };